<template>
	<div class="shop">
		<div class="bg" v-bg="'shop/bg.png'">
			<div class="shadows" v-bg="'shop/shadows.png'"></div>
		</div>	

		<div class="merchant">
			<div class="shadow"></div>
			<div class="illustration" v-bg="'shop/merchant.png'"></div>
		</div>

		<div class="bubble">
			<div class="bg" v-bg="'shop/bubble.png'"></div>	
			<div class="text">{{ 'merchant_sentence' | lang }}</div>
		</div>

		<div class="sign-wrap">
			<div class="sign">
				<div class="bg" v-bg="'shop/sign.png'"></div>
				<div class="sign-content" v-hammer:tap="reroll">
					<div class="text">Reroll</div>
					<div class="price" :class="{ expansive: shop_reroll_price > game.hero.gold }"><ui-gold :value="shop_reroll_price" /></div>
				</div>
			</div>
			<ui-tooltip title="Reroll" text="Besoin de voir d'autres talismans en stock ?" />
		</div>

		<div class="poster">
			<div class="poster-content">
				<!-- <div class="shadow" v-bg="'shop/poster-1.png'"></div> -->
				<div class="bg" v-bg="'shop/poster-' + poster + '.png'"></div>
				<!-- <div class="price"><ui-gold :value="10" /></div> -->
			</div>
			<div class="scotch" v-bg="'shop/scotch.png'"></div>
			<!-- <ui-tooltip title="Massage" text="Un bon massage qui vous rendra 3 points de vie." orientation="right" /> -->
		</div>

		<div class="content">
			<div class="table">
				<div class="bg" v-bg="'shop/table.png'"></div>
				<transition-group name="choice" class="choices" tag="div">
					<div v-for="(slot, index) in slots" :key="slot.id" class="choice" :class="[ 'p' + (index + 1), { expansive: get_card_price(slot.talisman) > game.hero.gold } ]">
						<div v-if="slot.talisman" class="price"><ui-gold :value="get_card_price(slot.talisman)" /></div>
						<div v-if="slot.talisman" class="talisman-wrap" v-hammer:tap="() => buy(slot)">
							<div class="shadow"></div>
							<talisman :talisman="slot.talisman" />
						</div>
						<ui-tooltip v-if="slot.talisman" :title="slot.talisman[lang].name" :text="slot.talisman[lang].description" />
					</div>
				</transition-group>
			</div>
			<div class="buttons">
				<ui-button v-hammer:tap="next">Continue</ui-button>
			</div>
		</div>

		<div class="foreground" v-bg="'shop/foreground.png'"></div>	

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Talisman from '@/components/global/talisman'
import UiGold from '@/components/ui/ui-gold'
import UiButton from '@/components/ui/ui-button'
import UiTooltip from '@/components/ui/ui-tooltip'
import { get_card_value } from '@/js/board'
import { sample } from '@/js/utils'

export default {
	name: 'shop',
	data() {
		return {
			poster: 1,
			visible: false
		}
	},
	computed: {
		...mapGetters([ 'lang', 'game', 'shop_reroll_price' ]),
		slots() {
			if (this.visible) {
				return this.game.shop.slots
			}
			return []
		}
	},
	methods: {
		get_card_price(talisman) {
			return get_card_value(talisman, 'price')
		},
		buy(slot) {
			if (this.get_card_price(slot.talisman) <= this.game.hero.gold) {
				this.$store.dispatch('buy_talisman', { slot })
			}
		},
		reroll() {
			if (this.shop_reroll_price <= this.game.hero.gold) {
				this.$store.dispatch('reroll_shop')
			}
		},
		next() {
			this.$store.dispatch('close_shop')
		}
	},
	created() {
		this.poster = sample([ 1, 2, 3 ])
	},
	mounted() {
		setTimeout(() => {
			this.visible = true
		}, 1000)
	},
	components: { Talisman, UiGold, UiButton, UiTooltip }
}
</script>

<style lang="stylus" scoped>

.shop
	absolute 0
	&.shop-enter-active
		transition 2s easeOutQuart 0.5s
		.merchant
			transition 0.35s easeOutQuart 0.5s
		.bubble
			transition 0.25s easeOutBack 0.8s
		.content
			transition 0.25s easeOutQuart
			.shadow
				transition 0.25s easeOutQuart
			.buttons
				transition 0.25s easeOutQuart 1.5s
		.sign-wrap
			transition 0.25s easeOutQuart
		.poster
			transition 0.25s easeOutQuart
	&.shop-enter
		.bg
			opacity 0
			transform scale(1.05)
		.foreground
			transform scale(1.5)
		.merchant
			transform translate(50%, 0)
			opacity 0
		.bubble
			opacity 0
			transform translate(48px, 32px) scale(0.9)
		.content
			transform translateY(24px)
			opacity 0
			.shadow
				opacity 0
			.buttons
				transform translateY(16px)
				opacity 0
		.sign-wrap
			transform translateX(-40px)
			opacity 0
		.poster
			transform translateY(-40px)
			opacity 0
			

	&.shop-leave-active
		transition 0.5s easeOutQuart
	&.shop-leave-to
		opacity 0
	
	> .bg
		absolute 0
		background bottom center no-repeat
		background-size cover
		transition 0.5s easeOutQuart
		.shadows
			absolute 0
			background bottom 165px left 80px no-repeat
			background-size (994px * 1.015) (147px * 1.015)
	
	> .foreground
		absolute 0
		background bottom center no-repeat
		background-size cover
		transition 0.5s easeOutQuart 0.25s
		pointer-events none

	.poster
		position absolute
		left 380px
		bottom 760px
		width (469px / 2.5)
		height (573px / 2.5)
		perspective 1000px
		// &:hover
		// 	>>> .ui-tooltip
		// 		visibility visible
		.scotch
			position absolute
			left 50%
			top 0px
			width (101px / 1.5)
			height (28px / 1.5)
			background-size contain
			transform translateX(-50%)
		.poster-content
			width 100%
			height 100%
			transform-origin center 8px
			transition 0.15s easeOutQuart
			// &:hover
			// 	transform rotateX(10deg)
			// 	.shadow
			// 		transform translate(4px, 10px)
			// &:active
			// 	transform rotateX(0)
			// 	.shadow
			// 		transform translate(0, 0)
			.shadow
				absolute 0
				background-size contain
				filter brightness(0)
				opacity 0.5
				transform translate(0,0)
				transition 0.15s easeOutQuart
			.bg
				absolute 0
				background-size contain
			.price
				position absolute
				left 50%
				bottom 42px
				transform translateX(-50%)
				font-size 4rem
				color #fff

	.sign-wrap
		position absolute
		left 70px
		bottom 338px
		width (240px / 1.2)
		height (379px / 1.2)
		perspective 1000px
		&:hover
			>>> .ui-tooltip
				visibility visible
				bottom calc(100% + 16px)
		.sign
			width 100%
			height 100%
			transform-origin bottom center
			transition 0.15s easeOutQuart
			&:hover
				transform scale(1) rotateX(-10deg)
			&:active
				transform scale(1) rotateX(10deg)
			.bg
				absolute 0
				background-size contain
			.sign-content
				position absolute
				left 8px
				right 16px
				top 14px
				height 120px
				flex center center column
				font-size 4.8rem
				color #792E3A
				.price
					&.expansive
						color red
						c = #fff
						text-shadow -1px -1px c, -1px 1px c, 1px 1px c, 1px -1px c

	.merchant
		position absolute
		right 0
		bottom 64px
		width round(1314px / 1.2)
		height round(1054px / 1.2)
		transform translate(25%, 0)
		.shadow
			position absolute
			left 25%
			right 20%
			bottom 0
			height 80px
			background-color #BC6055
			border-radius 50%
		.illustration
			absolute 0
			background center center no-repeat
			background-size contain
			transform-origin bottom center
			animation sprite-idle 3s easeInOutSine infinite alternate 0.2s
	.bubble
		position absolute
		right 450px
		bottom round(1054px / 1.6)
		color #fff
		width 650px
		height 256px
		padding 0 48px 80px 48px
		flex center center
		.bg
			absolute 0
			background-size contain
			.speach
				position absolute
				left calc(100% - 160px)
				top calc(100% - 24px)
				transform rotate(10deg)
				> svg
					width 150px
					height 80px
		&:after
			content ''
		.text
			font-size 4rem
			width 600px
			text-align center

	.content
		position absolute
		left 80px
		bottom 120px
		width 1014px
		height 400px
		// background-color alpha(red, 20%)
		// transform translateX(-50%)
		color #fff
		.table
			width 1014px
			height 336px
			.bg
				absolute 0
				background-size contain
			.choices
				position absolute
				left 200px
				top -64px
				flex center center
				width 700px
				height 140px
				// background-color alpha(red, 20%)
				.choice
					position absolute
					width 140px
					height 160px
					margin-left -70px
					font-size 4rem
					
					&.p1
						left 20%
					&.p2
						left 50%
					&.p3
						left 80%
					
					&.choice-enter-active
						transition 0.25s easeOutQuart 0.25s
						&.p1
							transition-delay 0.1s
						&.p2
							transition-delay 0.2s
						&.p3
							transition-delay 0.3s
					&.choice-enter
						transform translateY(-40px)
						opacity 0
						
					&.choice-leave-active
						transition 0.15s easeOutQuart
					&.choice-leave-to
						transform translateY(40px)
						opacity 0
					
					&:hover >>> .ui-tooltip
						visibility visible
						// transition-delay 0.15s
							
					&.expansive
						// .talisman-wrap
						// 	opacity 0.75
						.price
							color red
							c = #fff
							text-shadow -1px -1px c, -1px 1px c, 1px 1px c, 1px -1px c
					
					>>> .ui-tooltip
						bottom calc(100% + 56px)
						&:before
							height 96px
							bottom -@height
						
					.price
						position absolute
						left 0
						right 0
						bottom calc(100% - 8px)
						height 32px
						margin 0 0 16px 0
						flex center center
					.talisman-wrap
						width 100%
						height 100%
						flex center center
						transform-origin bottom center
						transition 0.1s easeOutQuart
						&:hover
							transform scale(1.05)
						&:active
							transform scale(1)
						>>> .talisman
							animation sprite-floating 2s easeInOutSine infinite alternate
						.shadow
							position absolute
							left 16px
							right 16px
							bottom 4px
							height 24px
							border-radius 50%
							background-color alpha(#000, 20%)
							animation shadow-floating 2s easeInOutSine infinite alternate
		.buttons
			height 200px
			flex center center
			transform translateY(-48px)
			>>> .ui-button
				margin 0 8px


@keyframes sprite-floating
	0%
		transform translateY(0)
	100%
		transform translateY(-8px)
		
@keyframes shadow-floating
	0%
		transform scale(1)
	100%
		transform scale(0.8)


@keyframes sprite-idle
	0%
		transform scaleY(1)
	100%
		transform scaleY(0.98)
		
</style>
